module.exports = {
    DELETE_MEETINGNOTE: "Are you sure you want to delete this meeting note?",
}